class TabsContainer extends HTMLElement {
  constructor() {
    super();

    this.tablist = this.querySelector('[role="tablist"]');
    this.tabs = this.tablist.querySelectorAll('[role="tab"]');
    this.tabPanels = this.querySelectorAll('[role="tabpanel"]');

    this.init();
  }

  init() {
    this.tabs.forEach((e) => {
      e.setAttribute("tabindex", "-1");
      e.setAttribute("aria-selected", "false");
    });

    window.location.href.indexOf("#panel") === -1
      ? this.activateFirstPanel()
      : this.checkInitialSelectedTab();

    this.determineTabindex();

    this.tabs.forEach(
      (button) => {
        button.addEventListener('click', function() {
          this.setSelectedTab(button);
          this.showActivePanel(button);
        }.bind(this));

        button.addEventListener("keydown", function (e) {
          if ((e.keyCode || e.which) === 32) {
            this.setSelectedTab(button);
            this.showActivePanel(button);
            button.click();
          }
        }.bind(this));
      }
    );
  }

  activateFirstPanel() {
    this.tabs[0].setAttribute("tabindex", "0");
    this.tabs[0].setAttribute("aria-selected", "true");
    this.tabPanels[0].classList.add("visible");
  }

  checkInitialSelectedTab() {
    const targetedTabPanel = this
      .querySelector(".tabpanel:target")
      .getAttribute("aria-labelledby");
    const selectedTab = this.querySelector(`#${targetedTabPanel}`);
    selectedTab.setAttribute("aria-selected", "true");
    selectedTab.removeAttribute("tabindex");
  };

  showActivePanel(element) {
    const selectedId = element.id;
    this.tabPanels.forEach((e) => {
      e.hidden = "true";
    });
    const activePanel = document.querySelector(
      `[aria-labelledby="${selectedId}"]`
    );
    activePanel.removeAttribute("hidden");
    activePanel.classList.add("visible");
    window.dispatchEvent(new Event('resize'));
  }

  setSelectedTab(element) {
    const selectedId = element.id;
    this.tabPanels[0].classList.remove("visible");

    this.tabs.forEach((e) => {
      const id = e.getAttribute("id");
      if (id === selectedId) {
        e.removeAttribute("tabindex", "0");
        e.setAttribute("aria-selected", "true");
      } else {
        e.setAttribute("tabindex", "-1");
        e.setAttribute("aria-selected", "false");
      }
    });
  }

  determineTabindex() {
    this.tabPanels.forEach((element) => {
      const focusableElements = element.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled]), details:not([disabled]), summary:not(:disabled)'
      ).length;

      focusableElements
        ? element.setAttribute("tabindex", "-1")
        : element.setAttribute("tabindex", "0");
    })
  }
}
customElements.define('tabs-container', TabsContainer);